import React, {
  FC,
  HTMLAttributes,
  MouseEvent,
  ReactNode,
  RefObject,
} from "react";

import classnames from "classnames";

import { StyledBubble } from "./Styles";

export interface IBubble {
  /** Children element. */
  children: ReactNode;
  /** Class names. */
  className?: string;
  /** Ref object for Bubble. */
  innerRef?: RefObject<HTMLDivElement>;
  /** Bubble styles. */
  style?: object;
  /** On click on bubble. */
  onClick?: (event: MouseEvent<HTMLElement>) => void;
  /** On mouse down event. */
  onMouseDown?: (event: MouseEvent<HTMLElement>) => void;
}

export const Bubble: FC<IBubble & HTMLAttributes<HTMLDivElement>> = ({
  children,
  className,
  innerRef = null,
  style = {},
  ...rest
}) => {
  return (
    <StyledBubble
      {...rest}
      ref={innerRef}
      className={classnames("c-bubble", className)}
      style={style}
    >
      {children}
    </StyledBubble>
  );
};

Bubble.displayName = "Bubble";
